import { CommonUtilities } from '../../commonUtils';
import globalSearchService from '../commonSearch/globalSearchServices';
import dashboardService from '../Dashboard/dashboardServices';
import directoryServices from '../directories/directoryServices';
import PeriodService from '../PeriodSelection/PeriodService';
import ClientProfileServices from '../User Profile/Client Profiles/clientProfileServices';
import commonServices from './commonServices';
import { openDB } from 'idb';

export default class cachingMechanisum {

    static individalcachingStorageBuild(apiCACHE: any) {

        var localStorageParam = {
            tagColor: { dataListing: {}, timeUpdate: '' },
            lookUpType: { dataListing: {}, timeUpdate: '' },
            ClientDetails: { dataListing: {}, timeUpdate: '' },
            SystemFormats: { dataListing: {}, timeUpdate: '' },
            SystemPeriod: { dataListing: {}, timeUpdate: '' },
            SiteTheme: { dataListing: {}, timeUpdate: '' },
            ClientImage: { dataListing: {}, timeUpdate: '' },
            ClientDSP: { dataListing: {}, timeUpdate: '' },
            labelList: { dataListing: {}, timeUpdate: '' },
        }
        let elapsed = 0;
        let localParameter: any;
        let getlocalTime: string | null = null;
        let cachingTime = 3600000;

        if (!localStorage.getItem('localParameter')) {
            localStorage.setItem('localParameter', JSON.stringify(localStorageParam));
        }

        if (localStorage.getItem('localParameter')) {
            localParameter = localStorage.getItem('localParameter');
        }

        if (apiCACHE === "tagColor" || apiCACHE === "All") {

            if (localParameter) {
                const parsed = JSON.parse(localParameter);
                getlocalTime = parsed?.tagColor?.timeUpdate || null;
            }

            if (getlocalTime) {
                const lastTime = new Date(getlocalTime).getTime();
                elapsed = Date.now() - lastTime;
            }

            //console.log(elapsed);
            //console.log(getlocalTime);

            if (!getlocalTime || elapsed > cachingTime) {

                dashboardService.tagColor().then((res: any) => {

                    const param = JSON.parse(localStorage.getItem('localParameter') || '{}');

                    param.tagColor = {
                        dataListing: res,
                        timeUpdate: new Date().toISOString()
                    };

                    localStorage.setItem('localParameter', JSON.stringify(param));
                });
            }

        }

        if (apiCACHE === "lookUpType" || apiCACHE === "All") {
            if (localParameter) {
                const parsed = JSON.parse(localParameter);
                getlocalTime = parsed?.lookUpType?.timeUpdate || null;
            }

            if (getlocalTime) {
                const lastTime = new Date(getlocalTime).getTime();
                elapsed = Date.now() - lastTime;
            }

            //console.log(elapsed);
            //console.log(getlocalTime);

            if (!getlocalTime || elapsed > cachingTime) {

                globalSearchService.lookUpTypeList().then((res: any) => {

                    const param = JSON.parse(localStorage.getItem('localParameter') || '{}');

                    param.lookUpType = {
                        dataListing: res,
                        timeUpdate: new Date().toISOString()
                    };

                    localStorage.setItem('localParameter', JSON.stringify(param));
                });
            }
        }

        if (apiCACHE === "ClientDetails" || apiCACHE === "All") {
            if (localParameter) {
                const parsed = JSON.parse(localParameter);
                getlocalTime = parsed?.ClientDetails?.timeUpdate || null;
            }

            if (getlocalTime) {
                const lastTime = new Date(getlocalTime).getTime();
                elapsed = Date.now() - lastTime;
            }

            //console.log(elapsed);
            //console.log(getlocalTime);

            if (!getlocalTime || elapsed > cachingTime) {
                directoryServices.getClientDetails().then((res: any) => {

                    const param = JSON.parse(localStorage.getItem('localParameter') || '{}');

                    param.ClientDetails = {
                        dataListing: res[0],
                        timeUpdate: new Date().toISOString()
                    };

                    localStorage.setItem('localParameter', JSON.stringify(param));
                });
            }
        }

        if (apiCACHE === "SystemFormats" || apiCACHE === "All") {
            if (localParameter) {
                const parsed = JSON.parse(localParameter);
                getlocalTime = parsed?.SystemFormats?.timeUpdate || null;
            }

            if (getlocalTime) {
                const lastTime = new Date(getlocalTime).getTime();
                elapsed = Date.now() - lastTime;
            }

            //console.log(elapsed);
            //console.log(getlocalTime);

            if (!getlocalTime || elapsed > cachingTime) {
                globalSearchService.systemFormatsList().then((res: any) => {

                    const param = JSON.parse(localStorage.getItem('localParameter') || '{}');

                    param.SystemFormats = {
                        dataListing: res,
                        timeUpdate: new Date().toISOString()
                    };

                    localStorage.setItem('localParameter', JSON.stringify(param));
                });
            }
        }

        if (apiCACHE === "SystemPeriod" || apiCACHE === "All") {
            if (localParameter) {
                const parsed = JSON.parse(localParameter);
                getlocalTime = parsed?.SystemPeriod?.timeUpdate || null;
            }

            if (getlocalTime) {
                const lastTime = new Date(getlocalTime).getTime();
                elapsed = Date.now() - lastTime;
            }


            if (!getlocalTime || elapsed > cachingTime) {
                PeriodService.PeriodCount().then((res: any) => {

                    const param = JSON.parse(localStorage.getItem('localParameter') || '{}');

                    param.SystemPeriod = {
                        dataListing: res,
                        timeUpdate: new Date().toISOString()
                    };

                    localStorage.setItem('localParameter', JSON.stringify(param));
                });
            }
        }

        if (apiCACHE === "SiteTheme" || apiCACHE === "All") {
            if (localParameter) {
                const parsed = JSON.parse(localParameter);
                getlocalTime = parsed?.SiteTheme?.timeUpdate || null;
            }

            if (getlocalTime) {
                const lastTime = new Date(getlocalTime).getTime();
                elapsed = Date.now() - lastTime;
            }

            if (!getlocalTime || elapsed > cachingTime) {
                commonServices.loadTheme().then((res: any) => {

                    const param = JSON.parse(localStorage.getItem('localParameter') || '{}');

                    param.SiteTheme = {
                        dataListing: res,
                        timeUpdate: new Date().toISOString()
                    };

                    localStorage.setItem('localParameter', JSON.stringify(param));
                });
            }
        }

        if (apiCACHE === "ClientImage" || apiCACHE === "All") {
            if (localParameter) {
                const parsed = JSON.parse(localParameter);
                getlocalTime = parsed?.ClientImage?.timeUpdate || null;
            }

            if (getlocalTime) {
                const lastTime = new Date(getlocalTime).getTime();
                elapsed = Date.now() - lastTime;
            }

            //console.log(elapsed);
            //console.log(getlocalTime);

            if (!getlocalTime || elapsed > cachingTime) {
                ClientProfileServices.getClientImage().then((res: any) => {

                    const param = JSON.parse(localStorage.getItem('localParameter') || '{}');

                    param.ClientImage = {
                        dataListing: res,
                        timeUpdate: new Date().toISOString()
                    };

                    localStorage.setItem('localParameter', JSON.stringify(param));
                });
            }
        }

        if (apiCACHE === "ClientDSPST") {
            if (localParameter) {
                const parsed = JSON.parse(localParameter);
                getlocalTime = parsed?.ClientDSP?.timeUpdate || null;
            }

            if (getlocalTime) {
                const lastTime = new Date(getlocalTime).getTime();
                elapsed = Date.now() - lastTime;
            }

            if (!getlocalTime || elapsed > cachingTime) {
                dashboardService.getClientDSPFull().then((res: any) => {

                    const param = JSON.parse(localStorage.getItem('localParameter') || '{}');

                    param.ClientDSP = {
                        dataListing: res,
                        timeUpdate: new Date().toISOString()
                    };
                    console.log(param);

                    global.ClientDSP = res;

                    localStorage.setItem('localParameter', JSON.stringify(param));
                });
            }
        }

        if (apiCACHE === "ClientDSP" || apiCACHE === "All") {
            openDB('MyAppDB', 1, {
                upgrade(db) {
                    if (!db.objectStoreNames.contains('cacheStore')) {
                        db.createObjectStore('cacheStore');
                    }
                }
            }).then((db) => {
                db.get('cacheStore', 'ClientDSP').then((cached) => {

                    let elapsed = 0;

                    if (getlocalTime) {
                        const lastTime = new Date(getlocalTime).getTime();
                        elapsed = Date.now() - lastTime;
                    }

                    //console.log(getlocalTime)
                    //console.log(elapsed)

                    if (!getlocalTime || elapsed > cachingTime) {
                        console.log("working ")
                        dashboardService.getClientDSPFull().then((res) => {
                            const updatedCache = {
                                dataListing: res,
                                timeUpdate: new Date().toISOString()
                            };

                            db.put('cacheStore', updatedCache, 'ClientDSP');

                            global.ClientDSP = res;
                        });
                    } else {
                        global.ClientDSP = cached.dataListing;
                    }
                });
            });
        }

        if (apiCACHE === "labelList" || apiCACHE === "All") {
            if (localParameter) {
                const parsed = JSON.parse(localParameter);
                getlocalTime = parsed?.ClientImage?.timeUpdate || null;
            }

            if (getlocalTime) {
                const lastTime = new Date(getlocalTime).getTime();
                elapsed = Date.now() - lastTime;
            }

            //console.log(elapsed);
            //console.log(getlocalTime);

            if (!getlocalTime || elapsed > cachingTime) {
                globalSearchService.loadlabelList().then((res: any) => {

                    const param = JSON.parse(localStorage.getItem('localParameter') || '{}');

                    param.labelList = {
                        dataListing: res,
                        timeUpdate: new Date().toISOString()
                    };

                    localStorage.setItem('localParameter', JSON.stringify(param));
                });
            }
        }
    }

    static getCachingStorage(apiCacheName: any) {

        let localParameter: any;
        let returnData: any;

        if (apiCacheName !== "ClientDSP") {
            if (!localStorage.getItem('localParameter')) {
                cachingMechanisum.individalcachingStorageBuild("All");
            }

            localParameter = localStorage.getItem('localParameter');
            if (localParameter) {
                localParameter = JSON.parse(localParameter);
            }

            const cache = localParameter?.[apiCacheName];
            const errorCode = cache?.dataListing?.errorCode;

            if (!cache || errorCode) {
                cachingMechanisum.individalcachingStorageBuild(apiCacheName);

                const updatedParameter = localStorage.getItem("localParameter");

                if (updatedParameter) {
                    localParameter = JSON.parse(updatedParameter);
                }
            }

            if (localParameter?.[apiCacheName]) {

                localParameter = localStorage.getItem('localParameter');
                if (localParameter) {
                    localParameter = JSON.parse(localParameter);
                }
            }

            returnData = localParameter?.[apiCacheName]?.dataListing || null;
            return returnData;
        }


        const length_test = returnData ? Object.keys(returnData).length : 0;

        /*if (apiCacheName === "ClientDSP" && length_test === 0) {
            console.log(apiCacheName)
            const db = await openDB('MyAppDB', 1, {
                upgrade(db) {
                    if (!db.objectStoreNames.contains('cacheStore')) {
                        db.createObjectStore('cacheStore');
                    }
                }
            });

            const data = await db.get('cacheStore', 'ClientDSP');
            console.log("Raw data from IndexedDB:", data); // Check what is actually returned

            if (data) {
                // Adjust based on your stored structure
                const returnData = data.dataListing ?? data;
                console.log("Returning:", returnData);
                return returnData;
            }

            return null;
        }*/
    }

    static async getClientDSPFromCache(apiCacheName: any) {
        const db = await openDB('MyAppDB', 1, {
            upgrade(db) {
                if (!db.objectStoreNames.contains('cacheStore')) {
                    db.createObjectStore('cacheStore');
                }
            }
        });

        const data = await db.get('cacheStore', 'ClientDSP');
        //console.log("Raw data from IndexedDB:", data); // Check what is actually returned

        if (data) {
            // Adjust based on your stored structure
            const returnData = data.dataListing ?? data;
            console.log("Returning:", returnData);
            return returnData;
        }

        return null;
    };




    static analyticCacheBuild(payload: any, data: any, caheKey: any) {

        let periodFrom = payload.periodFrom;
        let periodTo = payload.periodTo;
        let section = payload.Section ? payload.Section : payload.type;
        let pageNumber = payload?.pageNumber;
        let pageSize = payload?.pageSize;

        if (payload.activeAllTime && payload.activeAllTime === 1) {
            periodFrom = ' ';
            periodTo = ' ';
        }

        const cacheStore = caheKey + "_" + (section)
        const storedCacheKey =
            caheKey + "_" + section + "_" + (payload?.transaction_Ref ?? " ") + "_" + periodFrom + "_" + periodTo + "_" + (payload?.searchFor ?? " ") + "_" + pageNumber + "_" + pageSize;

        let dbName = "Analytic" + "_" + section;
        if (caheKey === "SinglePageSummary") {
            dbName = dbName + "_" + "Summary"
        } else {
            dbName = dbName + "_" + "Listing"
        }

        if (payload?.assetCode || payload?.AssetID) {
            dbName += "_AS_" + (payload?.assetCode ? payload.assetCode : payload.AssetID);
        }

        if (payload?.SubProvider || payload?.AccountCode) {
            dbName += "_SU_" + (payload?.SubProvider ? payload.SubProvider : payload.AccountCode);
        }

        if (payload?.companyName) {
            dbName += "_CN_" + payload.companyName;
        }

        if (payload?.kontactCode) {
            dbName += "_AR_" + payload.kontactCode;
        }

        console.log("analyticCacheBuild");
        console.log(payload)
        console.log("dbName " + dbName)
        console.log("cacheStore " + cacheStore)
        console.log("storedCacheKey " + storedCacheKey)

        openDB(dbName, 1, {
            upgrade(db) {
                if (!db.objectStoreNames.contains(cacheStore)) {
                    db.createObjectStore(cacheStore);
                }
            }
        }).then(db => {
            return db.put(cacheStore, data, storedCacheKey);
        }).then(() => {

        })
    }

    static analyticCacheBuildDel(payload: any, caheKey: any) {

        console.log(payload)
        console.log(caheKey)


        let periodFrom = payload.periodFrom;
        let periodTo = payload.periodTo;
        let section = payload.Section ? payload.Section : payload.type;
        let pageNumber = payload?.pageNumber;
        let pageSize = payload?.pageSize;

        if (payload.activeAllTime && payload.activeAllTime === 1) {
            periodFrom = ' ';
            periodTo = ' ';
        }

        const cacheStore = caheKey + "_" + (section)
        const storedCacheKey =
            caheKey + "_" + section + "_" + (payload?.transaction_Ref ?? " ") + "_" + periodFrom + "_" + periodTo + "_" + (payload?.searchFor ?? " ") + "_" + pageNumber + "_" + pageSize;

        let dbName = "Analytic" + "_" + section;
        if (caheKey === "SinglePageSummary") {
            dbName = dbName + "_" + "Summary"
        } else {
            dbName = dbName + "_" + "Listing"
        }

        if (payload?.assetCode || payload?.AssetID) {
            dbName += "_AS_" + (payload?.assetCode ? payload.assetCode : payload.AssetID);
        }

        if (payload?.SubProvider || payload?.AccountCode) {
            dbName += "_SU_" + (payload?.SubProvider ? payload.SubProvider : payload.AccountCode);
        }

        if (payload?.companyName) {
            dbName += "_CN_" + payload.companyName;
        }

        if (payload?.kontactCode) {
            dbName += "_AR_" + payload.kontactCode;
        }

        openDB(dbName, 1, {
            upgrade(db) {
                if (!db.objectStoreNames.contains(cacheStore)) {
                    db.createObjectStore(cacheStore);
                }
            }
        }).then(db => {
            return db.delete(cacheStore, storedCacheKey);
        }).then(() => {

        })

    }

    static async readFromStoredCacheKey(payload: any, caheKey: any) {

        let periodFrom = payload.periodFrom;
        let periodTo = payload.periodTo;
        let section = payload.Section ? payload.Section : payload.type;
        let pageNumber = payload?.pageNumber;
        let pageSize = payload?.pageSize;

        if (payload.activeAllTime && payload.activeAllTime === 1) {
            periodFrom = ' ';
            periodTo = ' ';
        }

        let dbName = "Analytic" + "_" + section
        if (caheKey === "SinglePageSummary") {
            dbName = dbName + "_" + "Summary"
        } else {
            dbName = dbName + "_" + "Listing"
        }

        if (payload?.assetCode || payload?.AssetID) {
            dbName += "_AS_" + (payload?.assetCode ? payload.assetCode : payload.AssetID);
        }

        if (payload?.SubProvider || payload?.AccountCode) {
            dbName += "_SU_" + (payload?.SubProvider ? payload.SubProvider : payload.AccountCode);
        }

        if (payload?.companyName) {
            dbName += "_CN_" + payload.companyName;
        }

        if (payload?.kontactCode) {
            dbName += "_AR_" + payload.kontactCode;
        }

        const cacheStore = caheKey + "_" + (section)
        const storedCacheKey =
            caheKey + "_" + section + "_" + (payload?.transaction_Ref ?? " ") + "_" + periodFrom + "_" + periodTo + "_" + (payload?.searchFor ?? " ") + "_" + pageNumber + "_" + pageSize;


        console.log("readFromStoredCacheKey");
        console.log(payload);
        console.log("dbName " + dbName);
        console.log("cacheStore " + cacheStore);
        console.log("storedCacheKey " + storedCacheKey);

        try {
            const db = await openDB(dbName, 1, {
                upgrade(db) {
                    if (!db.objectStoreNames.contains(cacheStore)) {
                        db.createObjectStore(cacheStore);
                    }
                }
            });

            const data = await db.get(cacheStore, storedCacheKey);
            //console.log("Retrieved data:", data);
            CommonUtilities.blockUiLoading(false);
            return data ?? null;

        } catch (error) {
            CommonUtilities.blockUiLoading(false);
            //console.error('Error accessing IndexedDB:', error);
            return null;
        }

    }
}